import type { CollisionPart } from './types';

// Generated from the approved 716 x 743 binary masks at a 0.5 threshold.
// Each connected white island is traced, simplified to a 4 px tolerance, and
// transformed with the matching display scale before it reaches Matter.
const RECIPES: Readonly<Record<string, readonly CollisionPart[]>> = {
  'assets/hitbox-masks/reverse-meerkat-hitbox-mask-20260831.png': [
    {
      id: 'silhouette', kind: 'polygon', x: 17.475, y: 10.493,
      vertices: [
        { x: -109.042, y: 43.378 }, { x: -106.72, y: 38.469 }, { x: -102.593, y: 35.11 },
        { x: -95.371, y: 34.335 }, { x: -89.955, y: 37.435 }, { x: -77.832, y: 32.526 },
        { x: -61.582, y: 31.751 }, { x: -51.007, y: 22.966 }, { x: -44.301, y: 13.148 },
        { x: -38.11, y: -0.029 }, { x: -21.602, y: -58.162 }, { x: -11.801, y: -80.899 },
        { x: -4.579, y: -90.717 }, { x: 4.707, y: -98.727 }, { x: 12.961, y: -103.119 },
        { x: 23.02, y: -105.703 }, { x: 35.143, y: -105.186 }, { x: 47.008, y: -100.277 },
        { x: 57.583, y: -90.459 }, { x: 64.289, y: -78.832 }, { x: 70.996, y: -47.311 },
        { x: 72.027, y: -0.545 }, { x: 74.091, y: 13.923 }, { x: 73.833, y: 19.608 },
        { x: 71.769, y: 22.191 }, { x: 67.384, y: 21.933 }, { x: 64.805, y: 17.541 },
        { x: 62.742, y: 3.072 }, { x: 62.226, y: -27.933 }, { x: 56.035, y: 2.555 },
        { x: 56.551, y: 46.478 }, { x: 55.004, y: 73.091 }, { x: 53.456, y: 79.033 },
        { x: 48.297, y: 81.875 }, { x: 41.333, y: 81.1 }, { x: 39.012, y: 78.258 },
        { x: 40.817, y: 64.823 }, { x: 39.27, y: 37.435 }, { x: 35.143, y: 78 },
        { x: 30.5, y: 81.1 }, { x: 25.083, y: 81.1 }, { x: 21.472, y: 78.516 },
        { x: 23.794, y: 65.598 }, { x: 24.052, y: 52.421 }, { x: 19.667, y: 0.488 },
        { x: 1.612, y: 43.895 }, { x: -21.087, y: 79.55 }, { x: -25.471, y: 83.167 },
        { x: -33.725, y: 83.167 }, { x: -36.563, y: 79.033 }, { x: -45.074, y: 83.167 },
        { x: -59.261, y: 84.717 }, { x: -84.796, y: 84.459 }, { x: -98.724, y: 81.617 },
        { x: -103.625, y: 78 }, { x: -106.72, y: 72.057 }, { x: -107.236, y: 62.497 },
        { x: -104.915, y: 53.454 }, { x: -108.526, y: 49.32 },
      ],
    },
  ],
  'assets/hitbox-masks/reverse-raccoon-hitbox-mask-20260902.png': [
    {
      id: 'body', kind: 'polygon', x: 10.858, y: 46.28,
      vertices: [
        { x: -69.986, y: 53.988 }, { x: -61.852, y: 42.725 }, { x: -59.037, y: 32.714 },
        { x: -60.914, y: 28.021 }, { x: -59.975, y: 21.452 }, { x: -55.595, y: 17.697 },
        { x: -51.215, y: 17.384 }, { x: -45.271, y: 22.077 }, { x: -42.143, y: 16.133 },
        { x: -26.813, y: -37.364 }, { x: -15.551, y: -58.012 }, { x: -5.227, y: -66.772 },
        { x: 10.103, y: -71.778 }, { x: 24.807, y: -70.213 }, { x: 34.818, y: -63.956 },
        { x: 42.014, y: -53.945 }, { x: 48.583, y: -33.61 }, { x: 51.712, y: -14.839 },
        { x: 53.276, y: 14.882 }, { x: 49.209, y: 21.139 }, { x: 41.701, y: 19.262 },
        { x: 38.572, y: 12.379 }, { x: 36.695, y: -5.766 }, { x: 33.88, y: 46.792 },
        { x: 31.377, y: 53.362 }, { x: 23.868, y: 55.239 }, { x: 20.74, y: 53.049 },
        { x: 20.427, y: 31.776 }, { x: 18.55, y: 48.357 }, { x: 15.734, y: 53.675 },
        { x: 9.164, y: 54.926 }, { x: 5.41, y: 52.111 }, { x: 6.036, y: 32.088 },
        { x: -2.411, y: 52.111 }, { x: -8.355, y: 58.368 }, { x: -14.925, y: 61.809 },
        { x: -23.685, y: 61.496 }, { x: -27.126, y: 56.803 }, { x: -40.266, y: 58.681 },
        { x: -50.59, y: 55.552 }, { x: -56.847, y: 60.245 }, { x: -62.478, y: 61.183 },
        { x: -67.796, y: 59.619 },
      ],
    },
    {
      id: 'sunglasses', kind: 'polygon', x: -47.424, y: -0.451,
      vertices: [
        { x: -16.397, y: -1.27 }, { x: -5.447, y: -7.214 }, { x: 11.447, y: -7.214 },
        { x: 16.765, y: -4.398 }, { x: 16.765, y: -2.208 }, { x: 10.821, y: 4.049 },
        { x: 4.564, y: 8.116 }, { x: -13.894, y: 6.551 },
      ],
    },
    {
      id: 'chain', kind: 'polygon', x: 83.421, y: 96.911,
      vertices: [
        { x: -14.282, y: 0.855 }, { x: -4.583, y: -1.335 }, { x: 6.992, y: -8.531 },
        { x: 13.875, y: -5.09 }, { x: 11.998, y: -0.71 }, { x: -0.203, y: 5.234 },
        { x: -13.03, y: 7.424 },
      ],
    },
  ],
  'assets/hitbox-masks/reverse-otter-hitbox-mask-20260831.png': [
    {
      id: 'silhouette', kind: 'polygon', x: 16.673, y: 23.046,
      vertices: [
        { x: 86.274, y: -110.594 }, { x: 85.687, y: -106.488 }, { x: 80.701, y: -99.449 },
        { x: 53.131, y: -73.639 }, { x: 53.131, y: -65.427 }, { x: 61.343, y: -49.296 },
        { x: 65.45, y: -36.391 }, { x: 66.916, y: -23.192 }, { x: 66.036, y: -9.701 },
        { x: 61.343, y: 11.123 }, { x: 54.891, y: 28.135 }, { x: 45.505, y: 44.266 },
        { x: 34.653, y: 56.291 }, { x: 21.748, y: 65.383 }, { x: 5.031, y: 70.956 },
        { x: 2.977, y: 75.649 }, { x: -3.768, y: 77.408 }, { x: -16.967, y: 76.822 },
        { x: -30.458, y: 72.129 }, { x: -64.187, y: 74.769 }, { x: -86.771, y: 74.182 },
        { x: -98.503, y: 70.369 }, { x: -116.394, y: 72.422 }, { x: -119.914, y: 70.369 },
        { x: -119.914, y: 68.609 }, { x: -115.514, y: 63.623 }, { x: -108.182, y: 59.517 },
        { x: -109.062, y: 52.185 }, { x: -107.595, y: 48.079 }, { x: -103.489, y: 45.146 },
        { x: -96.45, y: 28.135 }, { x: -87.358, y: 19.336 }, { x: -78.852, y: 14.936 },
        { x: -65.067, y: 11.71 }, { x: -50.696, y: 12.59 }, { x: -34.564, y: 18.749 },
        { x: -28.699, y: 15.523 }, { x: -20.78, y: 6.137 }, { x: -1.715, y: -38.444 },
        { x: 6.497, y: -50.762 }, { x: 17.349, y: -61.027 }, { x: 22.335, y: -70.706 },
        { x: 19.989, y: -79.212 }, { x: -4.062, y: -105.608 }, { x: -6.701, y: -112.061 },
        { x: -5.235, y: -116.167 }, { x: 6.204, y: -117.634 }, { x: 16.176, y: -115.58 },
        { x: 32.014, y: -108.835 }, { x: 39.933, y: -101.502 }, { x: 52.251, y: -109.421 },
        { x: 65.743, y: -113.527 }, { x: 80.114, y: -114.407 },
      ],
    },
  ],
  'assets/hitbox-masks/reverse-takenoko-hitbox-mask-20260831.png': [
    {
      id: 'silhouette', kind: 'polygon', x: 11.46, y: -0.083,
      vertices: [
        { x: -74.729, y: 20.404 }, { x: -70.958, y: 2.806 }, { x: -58.807, y: -14.373 },
        { x: -45.818, y: -23.591 }, { x: -31.991, y: -28.619 }, { x: -15.65, y: -29.457 },
        { x: -3.918, y: -26.524 }, { x: 6.975, y: -55.015 }, { x: 14.517, y: -64.233 },
        { x: 23.735, y: -69.68 }, { x: 38.819, y: -71.356 }, { x: 51.389, y: -65.909 },
        { x: 59.35, y: -54.596 }, { x: 63.121, y: -33.646 }, { x: 61.864, y: 38.84 },
        { x: 60.607, y: 46.8 }, { x: 56.417, y: 52.247 }, { x: 48.037, y: 52.247 },
        { x: 45.523, y: 49.314 }, { x: 47.199, y: 6.996 }, { x: 42.59, y: -29.457 },
        { x: 22.897, y: 33.812 }, { x: 16.193, y: 43.867 }, { x: 4.461, y: 51.409 },
        { x: -16.069, y: 55.599 }, { x: -39.533, y: 55.18 }, { x: -55.455, y: 51.828 },
        { x: -69.701, y: 39.259 },
      ],
    },
  ],
  'assets/hitbox-masks/reverse-koala-hitbox-mask-20260831.png': [
    {
      id: 'silhouette', kind: 'polygon', x: -5.912, y: -4.555,
      vertices: [
        { x: -0.457, y: -34.160 }, { x: 1.219, y: -36.841 }, { x: -7.496, y: -39.188 },
        { x: -12.524, y: -45.891 }, { x: -24.591, y: -44.215 }, { x: -31.965, y: -47.232 },
        { x: -37.663, y: -53.936 }, { x: -39.004, y: -61.646 }, { x: -35.987, y: -69.690 },
        { x: -28.278, y: -75.389 }, { x: -28.278, y: -85.445 }, { x: -23.920, y: -93.489 },
        { x: -13.529, y: -99.523 }, { x: -2.132, y: -99.523 }, { x: 3.231, y: -107.232 },
        { x: 11.275, y: -112.260 }, { x: 17.309, y: -113.936 }, { x: 30.717, y: -112.931 },
        { x: 38.426, y: -108.573 }, { x: 44.795, y: -99.188 }, { x: 54.516, y: -98.852 },
        { x: 60.884, y: -95.500 }, { x: 66.247, y: -88.461 }, { x: 67.253, y: -80.081 },
        { x: 76.303, y: -73.042 }, { x: 78.314, y: -63.992 }, { x: 75.633, y: -56.283 },
        { x: 66.918, y: -50.919 }, { x: 64.236, y: -44.215 }, { x: 58.873, y: -39.188 },
        { x: 46.136, y: -36.841 }, { x: 37.421, y: -40.193 }, { x: 37.756, y: -13.042 },
        { x: 43.789, y: -10.696 }, { x: 45.465, y: -7.679 }, { x: 44.460, y: 0.366 },
        { x: 37.756, y: 2.377 }, { x: 44.795, y: 9.751 }, { x: 43.454, y: 16.455 },
        { x: 38.091, y: 17.796 }, { x: 38.426, y: 50.645 }, { x: 47.141, y: 58.690 },
        { x: 45.800, y: 66.734 }, { x: 41.443, y: 69.081 }, { x: 46.806, y: 74.109 },
        { x: 50.493, y: 83.494 }, { x: 51.164, y: 96.902 }, { x: 48.482, y: 105.952 },
        { x: 50.493, y: 112.656 }, { x: 44.460, y: 112.991 }, { x: 36.750, y: 120.701 },
        { x: 25.018, y: 117.684 }, { x: 18.650, y: 113.662 }, { x: 9.935, y: 122.712 },
        { x: -3.808, y: 125.729 }, { x: -7.160, y: 123.717 }, { x: -7.496, y: 116.678 },
        { x: -2.803, y: 107.963 }, { x: -19.563, y: 113.997 }, { x: -22.244, y: 112.656 },
        { x: -20.233, y: 107.628 }, { x: -7.160, y: 96.902 }, { x: -4.144, y: 76.455 },
        { x: -23.920, y: 63.717 }, { x: -61.127, y: 49.304 }, { x: -75.876, y: 40.924 },
        { x: -87.272, y: 28.187 }, { x: -91.630, y: 11.092 }, { x: -89.283, y: 0.030 },
        { x: -84.255, y: -9.355 }, { x: -76.546, y: -17.400 }, { x: -68.166, y: -22.428 },
        { x: -52.412, y: -26.115 }, { x: -21.239, y: -27.120 },
      ],
    },
  ],
};

export function hitboxMaskCollisionParts(maskPath: string): readonly CollisionPart[] | undefined {
  return RECIPES[maskPath];
}
